<template>
    <div class="rpm-overview-modal">
        <!-- button -->
        <b-btn size="sm" @click="showModal()">
            <shs-icon name="book"></shs-icon>
        </b-btn>

        <!-- modal -->
        <b-modal size="xl"
                 no-close-on-backdrop
                 :id="modal_id">
            <template v-slot:modal-header>
                <h5 class="m-2">{{ $i18n.gt('HEADING_RPM_REVIEW') }}</h5>
                <patient-id :participant="participant">
                </patient-id>
            </template>

            <div class="accordion" role="tablist">
                <b-card no-body class="mb-1"
                    v-if="unbilledChecks.length">
                    <b-card-header header-tag="header" class="p-1" role="tab" v-b-toggle="'accordion-unbilled'">
                        <h5 class="m-1">{{ $i18n.gt('HEADING_UNBILLED_CHECKS') }}</h5>
                    </b-card-header>
                    <b-collapse id="accordion-unbilled" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <rpm-check-list
                                :checks="unbilledChecks">
                            </rpm-check-list>
                        </b-card-body>
                    </b-collapse>
                </b-card>
                <b-card no-body class="mb-1" v-for="(note, index) in notes" :key="index">
                    <b-card-header header-tag="header" class="p-1" role="tab" v-b-toggle="'accordion-note-' + index">
                        <h5 class="m-1">{{ $i18n.gt('HEADING_BILLED_CHECKS_FROM') }} {{note.lastupdated }}</h5>
                    </b-card-header>
                    <b-collapse :id="'accordion-note-' + index" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <rpm-check-list
                                :checks="note.rpm_checks">
                            </rpm-check-list>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: "RpmOverviewModal",
    props: {
        provider: Object,
    },
    computed: {
        modal_id() {
            return `rpm_overview_${this.provider.participant_id}`
        },
    },
    data() {
        return {
            unbilledChecks: [],
            notes: [],
        }
    },
    methods: {
        showModal() {
            this.$bvModal.show(this.modal_id)
            this.unbilledChecks = this.provider.participant.unbilled_checks
            // this.notes = this.provider.participant.rpm_notes
            this.notes = []//TODO refactor for SurveyNotes ? Or just get rid of this dang thing
        },
    },
})
</script>

<style scoped>

</style>
